import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-layout-unsaved-changes-dialog',
  templateUrl: './layout-unsaved-changes-dialog.component.html',
  styleUrls: ['./layout-unsaved-changes-dialog.component.css']
})
export class LayoutUnsavedChangesDialogComponent implements OnInit {

  enableSave = true;
  confirmDialog = false;
  dialogTitle = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<LayoutUnsavedChangesDialogComponent>
  ) {
    if (data) {
      this.enableSave = data.enableSave;
      this.confirmDialog = data.confirmDialog != undefined ? data.confirmDialog : false;
      this.dialogTitle = data.dialogTitle != undefined ? data.dialogTitle : "";
    }
  }

  ngOnInit() {
  }

  saveClick() {
    this.dialogRef.close('save');
  }

  SaveAsNewClick() {
    this.dialogRef.close('saveAsNew');
  }

  ContinueWithoutSaveClick() {
    this.dialogRef.close('continueWithoutSave');
  }

  cancelClick() {
    this.dialogRef.close('cancel');
  }
}
